module.exports = __webpack_public_path__ + "img/TelefonicaWeb-Bold.add3afe6.svg";